(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3893],{

/***/ 96655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11859);
/* harmony import */ var _components_core_SelectDropdown_SelectDropdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77860);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96301);
/* harmony import */ var _components_AccountsLayout_AccountsLayout_index_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50445);
/* harmony import */ var _components_AccountsLayout_AccountsLayout_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_components_AccountsLayout_AccountsLayout_index_module_scss__WEBPACK_IMPORTED_MODULE_5__);






const AccountsLayout = (param)=>{
    let { i18n , title , user , isAuth , logout , data , redirect , createNewlist , isSaveProductToList , createNewBtnText , isListDetailsPage =false , ...props } = param;
    const [width] = (0,_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var _activeTab;
    const [activeTab, setActive] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((_activeTab = props.activeTab) !== null && _activeTab !== void 0 ? _activeTab : 0);
    const [origin, setOrigin] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [isMobile, setIsMobile] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(width <= 1203);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setIsMobile(width <= _constants_index__WEBPACK_IMPORTED_MODULE_4__.PDP_SLIDER_SIZES.largeIpadSize);
    }, [
        width
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setOrigin(window.location.origin);
    }, []);
    const handleChange = (index)=>{
        setActive(index);
        redirect(data[index].url);
    };
    const getEventInfo = (title, index)=>{
        title = title === null || title === void 0 ? void 0 : title.toLowerCase();
        return JSON.stringify({
            eventAction: "my account:navigation:".concat(title),
            eventName: "my account:navigation:".concat(title),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: title,
            internalLinkPosition: "my account",
            internalLinkType: "my account:navigation",
            internalLinkZoneName: "my account:navigation",
            internalLinkURL: title !== "sign out" && data && data[index] && data[index].url ? (data[index].url.indexOf("http") === -1 ? origin : "") + data[index].url : title === "sign out" ? origin + "/en" : "n/a",
            clickInternalLinks: "true"
        });
    };
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_components_AccountsLayout_AccountsLayout_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accountTabsWrapper), " kf-react-container row no-gutters account-tabs ").concat(props.customClass ? props.customClass : "", " ").concat((props === null || props === void 0 ? void 0 : props.accountLayoutLoader) ? "accountLayoutLoader" : "pl-lg-0"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("aside", {
                className: "col-lg-3 account-tabs__nav-wrapper ".concat(isListDetailsPage ? "hide-nav" : ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "account-tabs__nav",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            id: "kf-user-name",
                            className: "account-tabs__message",
                            tabIndex: "0",
                            role: "alert",
                            children: "".concat(i18n.hi, " ").concat((ref = user === null || user === void 0 ? void 0 : user.firstName) !== null && ref !== void 0 ? ref : "")
                        }),
                        data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: !isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "account-tabs__list",
                                        role: "navigation",
                                        "aria-label": "Menu items navigation",
                                        children: data === null || data === void 0 ? void 0 : data.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                role: "link",
                                                "aria-selected": i === activeTab,
                                                "aria-label": ()=>i18n.menuItems(item.title),
                                                tabIndex: !isMobile ? 0 : -1,
                                                "data-gbh-data-layer": getEventInfo(item.title, i),
                                                className: "account-tabs__list-item gbh-data-layer ".concat(i === activeTab ? "--active" : ""),
                                                onClick: ()=>handleChange(i),
                                                children: item.title
                                            }, i))
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        tabIndex: !isMobile ? 0 : -1,
                                        role: "button",
                                        "aria-label": i18n.ariaSignOut,
                                        "data-gbh-data-layer": getEventInfo("sign out"),
                                        className: "account-tabs__sign-out gbh-data-layer",
                                        onClick: ()=>logout(),
                                        children: i18n.signOut
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "account-tabs__dropdown",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_SelectDropdown_SelectDropdown__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        id: "account-tab",
                                        data: data === null || data === void 0 ? void 0 : data.map((item)=>item.title),
                                        value: data[activeTab] ? data[activeTab].title : "",
                                        label: i18n.myAccount,
                                        onChange: (val)=>handleChange(data.findIndex((obj)=>obj.title === val))
                                    }),
                                    isSaveProductToList ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "create_new_list",
                                        onClick: createNewlist,
                                        children: createNewBtnText
                                    }) : null
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                className: "col-lg-9 account-tabs__wrapper-nav",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "account-tabs__content",
                    children: [
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "account-tabs__title",
                            children: title
                        }),
                        props.children
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AccountsLayout);


/***/ }),

/***/ 10030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const OrderProgressiveLoading = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "order-list",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "order-list__header",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "order-list__title width-full",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "shimmer-loading__title shimmer height-60"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "order-tile",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "order-tile__order-no",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "shimmer-loading__para30 shimmer width-170"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "order-tile__details",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                className: "order-tile__date",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "order-tile__label",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "shimmer-loading__para30 shimmer width-170"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "order-tile__value",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "shimmer-loading__para30 shimmer width-170"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                className: "order-tile__items",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "order-tile__label",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "shimmer-loading__para30 shimmer width-80"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "order-tile__value",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "shimmer-loading__para30 shimmer width-80"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                className: "order-tile__total",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "order-tile__label",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "shimmer-loading__para30 shimmer width-170"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "order-tile__value",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "shimmer-loading__para30 shimmer width-170"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                className: "order-tile__status",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "order-tile__label",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "shimmer-loading__para30 shimmer width-170"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "order-tile__value",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "shimmer-loading__para30 shimmer width-170"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "shimmer-loading__para30 shimmer width-170"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "order-tile",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "order-tile__order-no",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "shimmer-loading__para30 shimmer width-170"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "order-tile__details",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                className: "order-tile__date",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "order-tile__label",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "shimmer-loading__para30 shimmer width-170"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "order-tile__value",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "shimmer-loading__para30 shimmer width-170"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                className: "order-tile__items",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "order-tile__label",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "shimmer-loading__para30 shimmer width-80"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "order-tile__value",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "shimmer-loading__para30 shimmer width-80"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                className: "order-tile__total",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "order-tile__label",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "shimmer-loading__para30 shimmer width-170"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "order-tile__value",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "shimmer-loading__para30 shimmer width-170"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                className: "order-tile__status",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "order-tile__label",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "shimmer-loading__para30 shimmer width-170"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "order-tile__value",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "shimmer-loading__para30 shimmer width-170"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "shimmer-loading__para30 shimmer width-170"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OrderProgressiveLoading);


/***/ }),

/***/ 77860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_core_Input_Input__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3372);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96301);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8618);
/* harmony import */ var _components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_6__);







const SelectDropdown = (props)=>{
    const [showList, setShowList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [opened, setOpened] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [filteredData, setFilteredData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [filterText, setFilterText] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [isHighLighted, setIsHighLighted] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const { customClass , id , tabIndex , label , placeholder , ariaLabel , ariaRequired , value , ariaStateText , data , showError , errorMessage , showFilter , disabled =false , defaultFilterDisabled =false , autoComplete ="off" , ...restProps } = props;
    const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_4__["default"];
    const dropDownClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()({
        "select-dropdown": true,
        "dropdown--open": showList
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showList) {
            setOpened(true);
        } else if (!showList && opened && props.onClose) {
            props.onClose();
            setOpened(false);
        }
        const targetEelement = (e)=>{
            if (showList && document.getElementById(props.id) && !document.getElementById(props.id).contains(e.target)) {
                setShowList(false);
            }
        };
        document.addEventListener("click", targetEelement);
        return ()=>{
            document.removeEventListener("click", targetEelement);
        };
    }, [
        showList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setFilteredData(data);
    }, [
        data
    ]);
    const handleSelect = (value)=>{
        props.onChange(value);
        setShowList(false);
    };
    const handleMouseDownEvent = ()=>{
        setShowList(!showList);
    };
    const handleBlurEvent = (e)=>{
        if (!showFilter) {
            if (e instanceof MouseEvent) {
                setShowList(false);
            }
            if (typeof props.onBlur === "function") {
                props.onBlur();
            }
        }
    };
    const toggleList = ()=>{
        if (showList) {
            setShowList(false);
            document.getElementById(props.id).focus();
        } else {
            var ref;
            setShowList(true);
            (ref = document.getElementById("".concat(props.id, "-list"))) === null || ref === void 0 ? void 0 : ref.childNodes[0].focus();
        }
    };
    const btnKeyDown = (e)=>{
        switch(e.keyCode){
            case KEYCODE.SPACE:
                break;
            case KEYCODE.ENTER:
                e.preventDefault();
                toggleList();
                break;
            default:
                break;
        }
    };
    const handleKeyDown = (i, e)=>{
        const ele = document.getElementById("".concat(props.id, "-list")).childNodes;
        switch(e.keyCode){
            case KEYCODE.ESC:
                toggleList();
                break;
            case KEYCODE.UP:
                if (i > 0) ele[i - 1].focus();
                break;
            case KEYCODE.DOWN:
                if (i < ele.length - 1) ele[i + 1].focus();
                break;
            case KEYCODE.SPACE:
                break;
            case KEYCODE.ENTER:
                ele[i].addEventListener("click", ()=>{
                    document.getElementById(props.id).focus();
                });
                break;
            case KEYCODE.TAB:
                setShowList(false);
                break;
            default:
                break;
        }
    };
    const filterCityNames = (e)=>{
        var ref;
        if (defaultFilterDisabled) return;
        const key = e === null || e === void 0 ? void 0 : (ref = e.key) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        if ((key === null || key === void 0 ? void 0 : key.length) === 1 && (key === null || key === void 0 ? void 0 : key.match(_constants_index__WEBPACK_IMPORTED_MODULE_4__["default"].REGEX_CONTAINS_LETTER))) {
            const filtered = data === null || data === void 0 ? void 0 : data.filter((item)=>{
                return item === null || item === void 0 ? void 0 : item.toLowerCase().startsWith(key);
            });
            setFilteredData(filtered !== null && filtered !== void 0 ? filtered : data);
        } else if (key === "backspace") {
            setFilteredData(data);
        }
    };
    const handleChange = (e)=>{
        const { value  } = e.target;
        if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .checkAlphabetOnly */ .pJD)(value)) {
            setFilterText(value);
            const key = value.toLowerCase();
            const filtered = data === null || data === void 0 ? void 0 : data.filter((item)=>{
                if (item.toLowerCase().startsWith(key)) {
                    return item;
                }
            });
            setFilteredData(filtered !== null && filtered !== void 0 ? filtered : data);
        }
    };
    const handleInputKeyDown = (e)=>{
        if (KEYCODE.DOWN === e.keyCode) {
            setIsHighLighted(isHighLighted >= filteredData.length - 1 ? 0 : isHighLighted + 1);
        } else if (KEYCODE.UP === e.keyCode) {
            setIsHighLighted(isHighLighted > 0 ? isHighLighted - 1 : 0);
        } else if (KEYCODE.ENTER === e.keyCode) {
            handleSelect(filteredData.at(isHighLighted));
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setFilterText(value);
    }, [
        value
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (restProps.focus === true) setShowList(true);
    }, [
        restProps.focus
    ]);
    return disabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Input_Input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        type: "text",
        value: value,
        placeholder: placeholder,
        label: label,
        showError: showError,
        errorMessage: errorMessage,
        autoComplete: autoComplete,
        disabled: true
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            onClick: handleMouseDownEvent,
            onBlur: handleBlurEvent,
            className: "".concat(dropDownClass, " ").concat(customClass !== null && customClass !== void 0 ? customClass : ""),
            onKeyDown: filterCityNames,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    id: id,
                    className: "select-dropdown__field ".concat(showError ? "--with-error" : ""),
                    onKeyDown: btnKeyDown,
                    tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : 0,
                    role: "combobox",
                    "aria-controls": "dropdown-listbox",
                    "aria-expanded": showList,
                    "aria-haspopup": "true",
                    "aria-label": label ? label.replace(/\*/g, "") : ariaLabel ? ariaLabel.replace(/\*/g, "") : "",
                    "aria-required": (ariaRequired !== null && ariaRequired !== void 0 ? ariaRequired : label.indexOf("*") > 0) ? true : false,
                    "aria-describedby": "".concat(id, "-selected"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "select-dropdown__display",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    "aria-hidden": true,
                                    className: "select-dropdown__placeholder ".concat(value ? "--label" : ""),
                                    children: label
                                }),
                                showFilter && showList ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Input_Input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    type: "text",
                                    className: "inputfilter",
                                    onChange: handleChange,
                                    onKeyDown: handleInputKeyDown,
                                    value: filterText,
                                    placeholder: placeholder,
                                    label: label,
                                    autoComplete: true,
                                    autoFocus: true
                                }) : null,
                                value && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    id: "".concat(id, "-selected"),
                                    className: "select-dropdown__value",
                                    children: value
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "select-dropdown__icon ".concat(showList ? "--open" : ""),
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/icons/down-icon.svg",
                                alt: "open-icon"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                    id: "".concat(id, "-list"),
                    className: "select-dropdown__dropdown",
                    role: "listbox",
                    tabIndex: "-1",
                    "aria-expanded": "true",
                    "data-testid": "select-dropdown",
                    children: [
                        !ariaStateText && (filteredData === null || filteredData === void 0 ? void 0 : filteredData.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "select-dropdown__list-item ".concat(item === value && "selected-item", " ").concat(isHighLighted === i ? "highLighted" : ""),
                                "aria-selected": item === value,
                                role: "option",
                                tabIndex: "-1",
                                onClick: ()=>handleSelect(item),
                                onKeyDown: (e)=>handleKeyDown(i, e),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "select-dropdown__list-value",
                                    children: item
                                })
                            }, i))),
                        ariaStateText && (filteredData === null || filteredData === void 0 ? void 0 : filteredData.map((item, i)=>{
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "select-dropdown__list-item ".concat(item.code === value && "selected-item"),
                                "aria-selected": item === value,
                                role: "option",
                                tabIndex: "-1",
                                "aria-label": item.name,
                                onClick: ()=>{
                                    return handleSelect((props === null || props === void 0 ? void 0 : props.showStateName) ? item === null || item === void 0 ? void 0 : item.name : item === null || item === void 0 ? void 0 : item.code);
                                },
                                onKeyDown: (e)=>handleKeyDown(i, e),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "select-dropdown__list-value",
                                    children: (props === null || props === void 0 ? void 0 : props.showStateName) ? item === null || item === void 0 ? void 0 : item.name : item === null || item === void 0 ? void 0 : item.code
                                })
                            }, i);
                        }))
                    ]
                }),
                showError && errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    "aria-live": "polite",
                    role: "region",
                    className: "select-dropdown__error-message",
                    children: errorMessage
                })
            ]
        })
    });
};
SelectDropdown.defaultProps = {
    label: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectDropdown);


/***/ }),

/***/ 79540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AU": function() { return /* binding */ fetchOrders; },
/* harmony export */   "K0": function() { return /* binding */ setMenu; },
/* harmony export */   "ZI": function() { return /* binding */ getCardDetails; },
/* harmony export */   "lL": function() { return /* binding */ fetchOrderDataByEmailOrderId; }
/* harmony export */ });
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73350);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);
/* harmony import */ var _store_features_orderSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76977);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88032);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64757);







const getCardDetails = async (param)=>{
    let { url , cardId  } = param;
    try {
        var ref;
        const serviceList = await (0,_constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance */ .Gb)({
            url: _constants__WEBPACK_IMPORTED_MODULE_2__.GLOBAL_CONFIGURATION_ENDPOINT,
            params: {
                path: url
            }
        });
        if (serviceList === null || serviceList === void 0 ? void 0 : (ref = serviceList.data) === null || ref === void 0 ? void 0 : ref.cardTypes) {
            var ref1;
            const cardTypesList = await (0,_constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance */ .Gb)({
                url: _constants__WEBPACK_IMPORTED_MODULE_2__.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: serviceList === null || serviceList === void 0 ? void 0 : (ref1 = serviceList.data) === null || ref1 === void 0 ? void 0 : ref1.cardTypes
                }
            });
            if (cardTypesList && cardTypesList.data) {
                var ref2, ref3;
                var ref4;
                const cardValueText = (ref4 = (ref3 = cardTypesList === null || cardTypesList === void 0 ? void 0 : (ref2 = cardTypesList.data) === null || ref2 === void 0 ? void 0 : ref2.find((card)=>card.value === cardId)) === null || ref3 === void 0 ? void 0 : ref3.text) !== null && ref4 !== void 0 ? ref4 : "";
                return cardValueText;
            } else {
            // log.error(
            //   "Card Details: Error occured while fetching data from AEM"
            // )
            }
        }
    } catch (error) {
    // log.error(error)
    }
};
const setMenu = function(info, i18n, language) {
    let isSaveProductToList = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    const { accountSettingsPath , myFavoritesPagePath , orderHistoryPath , myProductsPath , myServicesPath  } = info;
    const urlsAndTitles = [
        {
            url: accountSettingsPath,
            title: i18n.accountSettings
        },
        {
            url: isSaveProductToList ? "/".concat(language).concat(_constants_routes__WEBPACK_IMPORTED_MODULE_5__/* .MY_LISTS_PAGE_PATH */ .PN) : myFavoritesPagePath,
            title: isSaveProductToList ? i18n.myLists : i18n.favorites
        },
        {
            url: orderHistoryPath,
            title: i18n.orders
        },
        {
            url: myProductsPath,
            title: i18n.myProducts
        },
        {
            url: myServicesPath,
            title: i18n.myServices
        }
    ];
    return urlsAndTitles.filter((param)=>{
        let { url  } = param;
        return url;
    }).map((param)=>{
        let { url , title  } = param;
        return {
            title,
            url
        };
    });
};
const getDaysDifference = (orderDate)=>{
    const currentDate = new Date();
    const timeDiff = orderDate.getTime() - currentDate.getTime();
    const daysDiff = timeDiff / _constants__WEBPACK_IMPORTED_MODULE_2__.TotalSecsForaDay;
    return daysDiff;
};
const fetchOrders = async ()=>{
    // #ToDo Make loading true
    const openOrders = [];
    const pastOrders = [];
    let postOrdersForUpsell = [];
    const openData = await _store__WEBPACK_IMPORTED_MODULE_4__/* .store.dispatch */ .h.dispatch((0,_store_features_orderSlice__WEBPACK_IMPORTED_MODULE_3__/* .getOpenOrders */ .x0)()).unwrap().then((response)=>response);
    const pastData = await _store__WEBPACK_IMPORTED_MODULE_4__/* .store.dispatch */ .h.dispatch((0,_store_features_orderSlice__WEBPACK_IMPORTED_MODULE_3__/* .getPastOrders */ .rx)()).unwrap().then((response)=>response);
    openData.forEach((order)=>{
        var ref, ref1;
        const orderDate = new Date(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(order, "createdAt", ""));
        const openDataArr = (ref = order.lineItems) === null || ref === void 0 ? void 0 : ref.filter((item)=>{
            var ref, ref1;
            return !((ref = item.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.find((attr)=>attr.name === "ComboSKU"));
        });
        const lineItemsData = (ref1 = order.lineItems) === null || ref1 === void 0 ? void 0 : ref1.filter((item)=>{
            var ref, ref1;
            return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
        });
        const daysDiff = getDaysDifference(orderDate);
        openOrders.push({
            orderNo: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(order, "orderNumber", ""),
            totalItems: openDataArr.reduce((a, b)=>{
                return a + b.quantity;
            }, 0),
            orderStatus: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(order, "state.obj.name.en-US", ""),
            orderDate: "".concat(orderDate.toLocaleString("default", {
                month: "long"
            }), " ").concat(orderDate.getDate(), ", ").concat(orderDate.getFullYear()),
            orderTotal: Number(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(order, "taxedPrice.totalGross.centAmount", 0) / 100).toFixed(2),
            lineItems: daysDiff < _constants__WEBPACK_IMPORTED_MODULE_2__.postOrderNoOfDays ? lineItemsData : []
        });
    });
    pastData.forEach((order)=>{
        var ref, ref1;
        const orderDate = new Date(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(order, "createdAt", ""));
        const pastDataArr = (ref = order.lineItems) === null || ref === void 0 ? void 0 : ref.filter((item)=>{
            var ref, ref1;
            return !((ref = item.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.find((attr)=>attr.name === "ComboSKU"));
        });
        const lineItemsData = (ref1 = order.lineItems) === null || ref1 === void 0 ? void 0 : ref1.filter((item)=>{
            var ref, ref1;
            return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
        });
        const daysDiff = getDaysDifference(orderDate);
        pastOrders.push({
            orderNo: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(order, "orderNumber", ""),
            totalItems: pastDataArr.reduce((a, b)=>{
                return a + b.quantity;
            }, 0),
            orderStatus: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(order, "state.obj.name.en-US", ""),
            orderDate: "".concat(orderDate.toLocaleString("default", {
                month: "long"
            }), " ").concat(orderDate.getDate(), ", ").concat(orderDate.getFullYear()),
            orderTotal: Number(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(order, "taxedPrice.totalGross.centAmount", 0) / 100).toFixed(2),
            lineItems: daysDiff < _constants__WEBPACK_IMPORTED_MODULE_2__.postOrderNoOfDays ? lineItemsData : []
        });
    });
    const placedOrders = openOrders.concat(pastOrders);
    if (placedOrders.length) {
        postOrdersForUpsell = placedOrders.filter((item)=>item.orderStatus !== "Cancelled").map((item)=>item.lineItems).flat(1);
    }
    return {
        openOrders,
        pastOrders,
        postOrdersForUpsell
    };
};
/**
 *
 * @param {String} email
 * @param {String} orderNo
 * @return {String} order details page url
 */ const fetchOrderDataByEmailOrderId = async (email, orderNo)=>{
    return await _store__WEBPACK_IMPORTED_MODULE_4__/* .store.dispatch */ .h.dispatch((0,_store_features_orderSlice__WEBPACK_IMPORTED_MODULE_3__/* .findOrderByEmail */ .Jv)({
        orderNo,
        email
    })).unwrap().then((response)=>response);
};


/***/ }),

/***/ 50445:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accountTabsWrapper":"AccountsLayout_accountTabsWrapper__BhnBp"};

/***/ }),

/***/ 8618:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SelectDropdown_wrapper__ot64Z"};

/***/ })

}]);